import trefoil from '../elements/trefoil.js';
trefoil.register();
